import { useMemo } from 'react';
import { useMatch } from 'react-router-dom';

function useStockCodeUrl() {
  const matchSDP = useMatch('/home/saham/:code');

  const stockCode = useMemo(() => {
    if (!matchSDP) {
      return null;
    }

    const { code } = matchSDP.params;

    return code;
  }, [matchSDP]);

  return stockCode;
}

export default useStockCodeUrl;
